import React, { useState } from "react";
const ExpandIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/portfolio/home/statsicons/expandfaq.svg";
export default function FaqQuestion({ question, answer }) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div
      className="gradientdiv faqquestion"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="faqquestionheader">
        <h4>{question}</h4>
        <img
          src={ExpandIcon}
          alt="expand"
          className={isExpanded ? "rotateimg" : "rotatezero"}
        />
      </div>
      {isExpanded && <p>{answer}</p>}
    </div>
  );
}
